import { render, staticRenderFns } from "./pos-extra-buttons-management.vue?vue&type=template&id=447a39c3"
import script from "./pos-extra-buttons-management.vue?vue&type=script&lang=js"
export * from "./pos-extra-buttons-management.vue?vue&type=script&lang=js"
import style0 from "./pos-extra-buttons-management.vue?vue&type=style&index=0&id=447a39c3&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports